import { Eye, LayoutList } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminLlmConfigRoutes } from './routes';
import { LLM_PRESET_PREVIEW_TAB } from './llmConfigPanels';

const navTab = {
  id: 'admin-nav',
  label: 'Navigation',
  icon: LayoutList,
  view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
} as const;

const navTabs = [navTab];
const panelReq = {
  left: { open: true, defaultActiveTab: 'admin-nav' },
  right: { open: false },
} as const;

export const adminLlmConfigManifest: FeatureManifest = {
  id: 'admin-llm-config',
  contexts: [
    CONTEXTS.ADMIN_LLM_FRAGMENTS,
    CONTEXTS.ADMIN_LLM_FRAGMENT_FORM,
    CONTEXTS.ADMIN_LLM_PRESETS,
    CONTEXTS.ADMIN_LLM_PRESET_FORM,
  ],

  routes: [{ routes: adminLlmConfigRoutes, errorFallbackLabel: 'LLM Config', guard: ADMIN_GUARD }],

  centerView: {
    [CONTEXTS.ADMIN_LLM_FRAGMENTS]: lazyView(
      () => import('../views/LlmFragmentListView'),
      'LlmFragmentListView',
    ),
    [CONTEXTS.ADMIN_LLM_FRAGMENT_FORM]: lazyView(
      () => import('../views/LlmFragmentDetailView'),
      'LlmFragmentDetailView',
    ),
    [CONTEXTS.ADMIN_LLM_PRESETS]: lazyView(
      () => import('../views/LlmPresetListView'),
      'LlmPresetListView',
    ),
    [CONTEXTS.ADMIN_LLM_PRESET_FORM]: lazyView(
      () => import('../views/LlmPresetDetailView'),
      'LlmPresetDetailView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_LLM_FRAGMENTS]: navTabs,
        [CONTEXTS.ADMIN_LLM_FRAGMENT_FORM]: navTabs,
        [CONTEXTS.ADMIN_LLM_PRESETS]: navTabs,
        [CONTEXTS.ADMIN_LLM_PRESET_FORM]: navTabs,
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_LLM_PRESET_FORM]: [
          {
            id: LLM_PRESET_PREVIEW_TAB,
            label: 'Aperçu',
            icon: Eye,
            view: lazyView(() => import('../views/LlmPresetPreviewView'), 'LlmPresetPreviewView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_LLM_FRAGMENTS]: panelReq,
    [CONTEXTS.ADMIN_LLM_FRAGMENT_FORM]: panelReq,
    [CONTEXTS.ADMIN_LLM_PRESETS]: panelReq,
    // Compilation à blanc du preset — utile en continu pendant l'édition.
    [CONTEXTS.ADMIN_LLM_PRESET_FORM]: {
      left: panelReq.left,
      right: { open: true, defaultActiveTab: LLM_PRESET_PREVIEW_TAB },
    },
  },
};
